import React from "react";

import {FieldValues} from 'react-hook-form';

interface LabelComponentProps<T extends FieldValues = FieldValues> {
    label: string;
    required: boolean;
    htmlFor?: string;
}

function Label({required, label, htmlFor}: LabelComponentProps) {
    return (
        <div className="label">
            <label
                htmlFor={htmlFor}
                className="block text-sm font-medium leading-6 text-gray-900"
            >
                {label}
                {required && (<span className="text-red"> *</span>)}
            </label>
        </div>
    );
}

export default Label;